/*
 * @NOTE(Grey): If we are going to pass any more Hubspot form options through
 * I will need to change how I handle those
 */

function form_make(options) {
    console.assert(options.portalId);
    console.assert(options.formId);

    function form_init() {
        $.getJSON('https://ipapi.co/json/').always(function(data) {
            hbspt.forms.create({
                region: 'na1',
                portalId: options.portalId,
                formId: options.formId,
                target: options.target || '',
                css: '',
                onFormReady: function($form) {
                    if (options.onReady) {
                        options.onReady($form);
                    }

                    if (data.ip) {
                        $form.find('input[name=ip_address]').val(data.ip).change();
                    } else {
                        $form.find('input[name=ip_address]').val('No IP address').change();
                    }

                    if (data.city) {
                        $form.find('input[name=ip_location]').val(data.city).change();
                    } else {
                        $form.find('input[name=ip_location]').val('No location').change();
                    }
                },
                onFormSubmit: function($form) {
                    if (options.onSubmit) {
                        options.onSubmit($form);
                    }
                },
            });
        });
    };

    document.onreadystatechange = function() {
        if (document.readyState === "interactive") {
            form_init();
        } else {
            document.addEventListener('DOMContentLoaded', form_init, false);
        }
    }
}


window.form_make = form_make;